import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { StoreCard } from "../../../lib/types/detailsTypes";

/**
 * Return all *visible* loyalty cards for a user
 * (membership.isHidden === false).
 */
export const getFirestoreCards = async (
  userID: string
): Promise<StoreCard[]> => {
  const cards: StoreCard[] = [];

  try {
    /* 1️⃣  memberships that are *not* hidden */
    const membershipsQ = query(
      collection(db, "users", userID, "memberships"),
      where("isHidden", "==", false)
    );

    const membershipsSnap = await getDocs(membershipsQ);

    for (const membership of membershipsSnap.docs) {
      const storeID = membership.id; // membership doc ID = storeID

      /* 2️⃣  store metadata (one read per store) */
      const storeSnap = await getDoc(doc(db, "stores", storeID));
      const storeData = storeSnap.exists() ? storeSnap.data() : {};

      /* 3️⃣  all loyalty cards under this membership */
      const cardsSnap = await getDocs(
        collection(
          db,
          "users",
          userID,
          "memberships",
          storeID,
          "customerLoyaltyCards"
        )
      );

      for (const cardDoc of cardsSnap.docs) {
        const cardData = cardDoc.data();
        const cardDocId = cardDoc.id;

        /* 4️⃣  template metadata */
        const templateSnap = await getDoc(
          doc(db, "stores", storeID, "loyaltyCards", cardDocId)
        );
        const templateData = templateSnap.exists() ? templateSnap.data() : {};

        /* 5️⃣  merge — store ▸ template ▸ user-card */
        cards.push({
          id: cardDocId,
          ...storeData,
          ...templateData,
          ...cardData,
        } as StoreCard);
      }
    }
  } catch (err) {
    console.error("Error fetching wallet cards:", err);
    return [];
  }

  return cards;
};
